import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { toast, Toaster } from "react-hot-toast";

export default function Contact() {
  const location = useLocation();
  const navUser = location.state?.user || null;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Prefill name & email if user is passed from Navbar
  useEffect(() => {
    if (navUser) {
      setName(navUser.name || "");
      setEmail(navUser.email || "");
    }
  }, [navUser]);

  // Clear fields on logout
  useEffect(() => {
    const handleUserLogout = () => {
      setName("");
      setEmail("");
      setMessage("");
    };
    window.addEventListener("userLoggedOut", handleUserLogout);
    return () => window.removeEventListener("userLoggedOut", handleUserLogout);
  }, []);

  // -------------------- Handle Submit --------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const res = await fetch(
        "https://supizza-backend.onrender.com/api/auth/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email, message }),
        },
      );

      const data = await res.json();

      if (data.success) {
        toast.success("Message sent successfully!", {
          position: "bottom-right",
        });
        // Clear fields after submission
        setName(navUser?.name || "");
        setEmail(navUser?.email || "");
        setMessage("");
        setSubmitting(false);
      } else {
        toast.error(data.message || "Something went wrong", {
          position: "bottom-right",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Server error", { position: "bottom-right" });
    }
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <div className="flex flex-col w-full border-b pt-20">
        {/* ---------------- Contact Details Section ---------------- */}
        <div className="flex flex-col md:flex-row py-10 lg:py-20 gap-2 md:gap-5 lg:gap-10 px-5 lg:px-20 2xl:px-[10%] fhd:px-[15%] 4k:px-[25%]">
          {/* Left Side Info */}
          <div className="flex flex-col w-full md:w-[40%] lg:w-[30%]">
            <h1 className="text-2xl md:text-3xl text-gray-800   capitalize pb-5 md:pb-10">
              Contact details
            </h1>

            <div className="flex flex-col gap-2 lg:gap-3 pt-7 pb-5 border-b">
              <h1 className=" text-lg md:text-xl text-gray-800 capitalize">
                Address
              </h1>
              <p className="text-xs lg:text-sm text-slate-500 capitalize">
                14 street 2 Jinnah Colony, Sarai Alamgir
              </p>
            </div>

            <div className="flex flex-col gap-2 lg:gap-3 pt-7 pb-5 border-b">
              <h1 className=" text-lg md:text-xl text-gray-800 capitalize">
                Phone
              </h1>
              <p className="text-xs lg:text-sm text-slate-500">
                +92 332 4384033
              </p>
            </div>

            <div className="flex flex-col gap-2 lg:gap-3 pt-7 pb-5 border-b">
              <h1 className=" text-lg md:text-xl text-gray-800 capitalize">
                Email
              </h1>
              <p className="text-xs lg:text-sm text-slate-500">
                support@supizza.online
              </p>
            </div>

            <div className="flex flex-col gap-2 lg:gap-3 pt-7 pb-5 border-b">
              <h1 className=" text-lg md:text-xl text-gray-800 capitalize">
                Opening Time
              </h1>
              <p className="text-xs lg:text-sm text-slate-500 capitalize">
                12:00pm - 12:00am, Fri - Closed
              </p>
            </div>

            <div className="flex flex-col gap-2 lg:gap-3 pt-7 pb-1">
              <h1 className=" text-lg md:text-xl text-gray-800 capitalize">
                Follow us on
              </h1>
              <div className="flex gap-3 text-sm lg:text-lg text-gray-600">
                <div className="p-2 rounded-full border cursor-pointer  hover:bg-red-600 hover:text-white duration-300">
                  <FaXTwitter />
                </div>
                <div className="p-2 rounded-full border cursor-pointer  hover:bg-red-600 hover:text-white duration-300">
                  <FaFacebookF />
                </div>
                <div className="p-2 rounded-full border cursor-pointer hover:text-white hover:bg-red-600 duration-300">
                  <FaInstagram />
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Map */}
          <div className="flex w-full md:w-[60%] lg:w-[70%]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d537.7970819758706!2d73.76338139872459!3d32.906658084825324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1773402566378!5m2!1sen!2s"
              width="600"
              height="450"
              allowFullScreen
              loading="lazy"
              className="w-full h-[300px] md:h-[100%]"
            />
          </div>
        </div>

        {/* ---------------- Contact Form ---------------- */}
        <div className="flex flex-col w-full 2xl:w-auto bg-gray-100 py-20 px-5 2xl:mx-[10%] fhd:mx-[15%] 4k:mx-[25%]">
          <div className="flex flex-col items-center gap-1 lg:gap-3">
            <h1 className="text-2xl lg:text-4xl  capitalize ">
              Send us your Questions
            </h1>
            <p className="text-xs lg:text-base text-gray-500">
              We'll get back to you ASAP.
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full md:px-[15%] mt-16 justify-center-items-center gap-10"
          >
            <div className="flex flex-col md:flex-row w-full gap-10 items-center">
              <div className="w-full md:w-1/2">
                <label
                  htmlFor="name"
                  className="capitalize text-sm lg:text-md font-[500] text-gray-800 mb-3"
                >
                  Full Name*
                </label>
                <input
                  id="name"
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="flex w-full py-4 px-3 border border-black"
                />
              </div>

              <div className="w-full md:w-1/2">
                <label
                  htmlFor="email"
                  className="capitalize text-sm lg:text-md font-[500] text-gray-800 mb-3"
                >
                  Email*
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex w-full py-4 px-3 border border-black"
                />
              </div>
            </div>

            <div className="flex flex-col w-full gap-10">
              <div className="flex w-full">
                <div className="w-full">
                  <label
                    htmlFor="message"
                    className="capitalize text-sm lg:text-md font-[500] text-gray-800 mb-3"
                  >
                    Full Message*
                  </label>
                  <textarea
                    id="message"
                    required
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="flex w-full border h-[300px] border-black overflow-y-visible"
                  />
                </div>
              </div>

              <div className="w-full flex justify-center">
                <input
                  type="submit"
                  disabled={submitting}
                  className={`block w-max py-4 px-20 uppercase tracking-[1px] text-white duration-300
      ${
        submitting
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-gray-600 hover:bg-red-700"
      }
    `}
                  value={submitting ? "Submitting..." : "Submit"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
